'use client';

import Script from 'next/script';
import { useEffect } from 'react';

export type TrustedFormProps = {
  id: string;
  testId: string;
  onCertUrl?: (value: string) => void;
};

const field = 'xxTrustedFormCertUrl';

export function TrustedForm({ id, testId, onCertUrl }: TrustedFormProps) {
  useEffect(() => {
    const interval = setInterval(() => {
      const input = document.getElementsByName(
        field,
      )[0] as HTMLInputElement | null;

      const val = input?.value;

      if (val) {
        clearInterval(interval);
        onCertUrl?.(val);
      }
    }, 300);

    return () => {
      clearInterval(interval);
    };
  }, [onCertUrl]);

  return (
    <Script
      id={id}
      data-testid={testId}
      src={`https://api.trustedform.com/trustedform.js?provide_referrer=false&field=${field}&invert_field_sensitivity=false&l=${Date.now().toString()}${Math.random().toString()}`}
    />
  );
}
